export default "__VITE_PUBLIC_ASSET__01550580__"